<template>
    <div class="c2b-container">
        <div class="c2b-router-name-container">
            <p class="c2b-router-name">Principal</p>
        </div>

        <div class="c2b-content">
            <div class="row">
                <div class="col-12 mb-3">
                    <BillingSimpleGraphicCmp />
                </div>

                <div class="col-12 mb-3">
                    <BillingByTypeBySourceGraphicCmp />
                </div>


                <div class="col-12 mb-3">
                    <SubscribersChurnGraphicCmp />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BillingSimpleGraphicCmp from '../components/BillingSimpleGraphicCmp'
import BillingByTypeBySourceGraphicCmp from '../components/BillingByTypeBySourceGraphicCmp'
import SubscribersChurnGraphicCmp from '../components/SubscribersChurnGraphicCmp'

export default {
    name: 'DashboardView',
    components: {
        BillingSimpleGraphicCmp,
        BillingByTypeBySourceGraphicCmp,
        SubscribersChurnGraphicCmp,
    },
}
</script>